import React from 'react';
import AppRoutes from './routes/AppRoutes';
import MainLayout from './layouts/MainLayout';
import { useToolpadRouter } from './hooks/useToolpadRouter';
import 'font-awesome/css/font-awesome.min.css';

import { VillageProvider } from './context/VillageContext';

import '../src/styles/global.css';
function App() {

  const router = useToolpadRouter(); // 👈 Use custom router

  const [session, setSession] = React.useState({
    user: {
      name: 'Bharat Kashyap',
      email: 'bharatkashyap@outlook.com',
      image: 'https://avatars.githubusercontent.com/u/19550456',
    },
  });

  const authentication = React.useMemo(() => ({
    signIn: () => {
      setSession({
        user: {
          name: 'Bharat Kashyap',
          email: 'bharatkashyap@outlook.com',
          image: 'https://avatars.githubusercontent.com/u/19550456',
        },
      });
    },
    signOut: () => setSession(null),
  }), []);

  const authRoutes = ['/login', '/register'];
  const isAuthRoute = authRoutes.includes(router.pathname);

  // Handle authentication routes separately
  if (isAuthRoute) {
    return <AppRoutes />;
  }

  // For all other routes, use the MainLayout
  return (
    <VillageProvider>
    <MainLayout
      session={session}
      authentication={authentication} 
      router={router}
    >
      <AppRoutes />
    </MainLayout>
    </VillageProvider>
  );
}

export default App;
